export const loginDictionary = {
  title: 'Admin paneli',
  secretKey: "Maxfiy so'z",
  kiriting: 'Foydalanuvchi nomingiz va parolingizni kiriting!',
}
